import { z } from "zod";

/**
 * DeleteAgentResponseSchema
 *
 * Body returned by DELETE /api/agents/:id.
 * Returns the deleted agent's ID for cache invalidation on the client.
 */
export const DeleteAgentResponseSchema = z.object({
  id: z.string()
});

export type DeleteAgentResponse = z.infer<typeof DeleteAgentResponseSchema>;
